import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';
import Icon from '../../../components/AppIcon';

const SubmissionTrendsChart = ({ trends, loading }) => {
  if (loading) {
    return (
      <div className="glass-card p-6 rounded-2xl">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="h-64 bg-gray-100 rounded"></div>
        </div>
      </div>
    );
  }

  const chartData = trends?.map(trend => ({
    ...trend,
    displayDate: format(new Date(trend.date), 'dd/MM')
  }));

  return (
    <div className="glass-card p-6 rounded-2xl">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name="TrendingUp" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Tendances de soumission</h3>
          <p className="text-sm text-muted-foreground">Évolution des adressages sur 30 jours</p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey="displayDate" 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <YAxis 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
          />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="total" 
            stroke="#2563eb" 
            strokeWidth={2}
            name="Total"
            dot={{ fill: '#2563eb', r: 4 }}
          />
          <Line 
            type="monotone" 
            dataKey="urgent" 
            stroke="#f59e0b" 
            strokeWidth={2}
            name="Urgent"
            dot={{ fill: '#f59e0b', r: 4 }}
          />
          <Line 
            type="monotone" 
            dataKey="emergency" 
            stroke="#ef4444" 
            strokeWidth={2}
            name="Urgence"
            dot={{ fill: '#ef4444', r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
      <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-gray-200">
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 mb-1">
            <div className="w-3 h-3 rounded-full bg-primary"></div>
            <p className="text-sm font-medium text-muted-foreground">Total</p>
          </div>
          <p className="text-2xl font-bold text-foreground">
            {chartData?.reduce((sum, d) => sum + d?.total, 0)}
          </p>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 mb-1">
            <div className="w-3 h-3 rounded-full bg-warning"></div>
            <p className="text-sm font-medium text-muted-foreground">Urgent</p>
          </div>
          <p className="text-2xl font-bold text-foreground">
            {chartData?.reduce((sum, d) => sum + d?.urgent, 0)}
          </p>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 mb-1">
            <div className="w-3 h-3 rounded-full bg-error"></div>
            <p className="text-sm font-medium text-muted-foreground">Urgence</p>
          </div>
          <p className="text-2xl font-bold text-foreground">
            {chartData?.reduce((sum, d) => sum + d?.emergency, 0)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubmissionTrendsChart;